
import { useState, useEffect } from "react";

import { Helmet } from "react-helmet";

import moment from "moment";

import DataTable from "react-data-table-component";
import Input from "../../../components/input";

/* MATERIAL TAILWIND COMPONENTS */
import { Button, Dialog, DialogBody } from "@material-tailwind/react";

/* ICONS */
import { FiTrash } from "react-icons/fi";
import { IoClose } from "react-icons/io5";

/* TOAST NOTIFICATION */
import { toast } from "react-toast";


/* API IMPORT */
import { deleteContactUsDetailsById, getContactUsList } from "../../../service/api/contactUs.api";
import { handleAddToken } from "../../../service/request";
import { useSelector } from "react-redux";


const ContactUs = () => {
  // GLOBAL VARIALBES
  const userDetails = useSelector((state) => state?.user);
  // STATE VARIABLES 
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);

  const [contactUsList, setContactUsList] = useState([]);

  const [totalDocs, setTotalDocs] = useState([]);

  const [search, setSearch] = useState("");

  const [deleteId, setDeleteId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  /* FUNCTIONS */
  const handlePageChange = async (e) => {
    setPage(e)
    getContactUsListFunction();
  };

  const handlePerPageChange = async (e) => {
    setSizePerPage(e)
    getContactUsListFunction();
  };

  const getContactUsListFunction =async () => {
    await handleAddToken(userDetails?.token);
    setLoading(true);
    const params = {
      page: page,
      sizePerPage: sizePerPage,
      pagination : true 
    };
    if (search) {
      params.search = search
    }

    getContactUsList(params)
      .then((res) => {
        setContactUsList(res?.data?.docs);
        setTotalDocs(res?.data?.totalDocs);
      })
      .catch((e) => {
        console.log("e-->", e);
      }).finally(() => {
        setLoading(false);
      });
  };

  /* HANDLE DELETE DATA */
  const handleDelete = async () => {
    try {
      await handleAddToken(userDetails?.token);
      const res = await deleteContactUsDetailsById(deleteId);
      toast.success(res?.message);
      await getContactUsListFunction();
    } catch (e) {
      toast.error(e?.response?.data?.message || 'An error occurred');
    } finally {
      setDeleteModal(!deleteModal);
      setDeleteId(null);
    }
  };
  

  
  /* GET INITIALS */
  const getInitials = (string1, string2) => {

    function extractFirstLetter(string) {
      let extractedString = [];

      for (var i = 0; i < string?.length; i++) {
        if (
          (string?.charAt(i) === string?.charAt(i).toUpperCase() ||
            string?.charAt(i) === string?.charAt(i).toLowerCase()) &&
          string?.charAt(i) !== " "
        ) {
          extractedString.push(string?.charAt(i).toUpperCase());
        }
      }
      if (extractedString.length > 1) {
        return extractedString[0];
      } else {
        return extractedString[0];
      }
    }
    let letterOne = extractFirstLetter(string1);
    let letterTwo = extractFirstLetter(string2);
    if (letterOne !== undefined && letterTwo !== undefined) {
      return letterOne + letterTwo;
    }
    else if (letterOne === undefined && letterTwo !== undefined) {
      return letterTwo;
    }
    else if (letterOne !== undefined && letterTwo === undefined) {
      return letterOne;
    }
    else {
      return "";
    }

  };

  /* COLUMNS */
  const columns = [
    {
      name: "Sr. No",
      width: "10vh",
      selector: (row, index) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {index + 1}
        </span>
      ),
    },
    {
      name: "Name",
      width: "25vh",
      selector: (row) => (
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-full flex items-center justify-center bg-logoYellow text-sm font-proxima-semibold text-white">
            {getInitials(row.firstName, row.lastName)}
          </div>
          <p className="text-sm font-proxima-semibold text-black text-opacity-60">
            {row.firstName} {row?.lastName}
          </p>
        </div>
      ),
    },
    {
      name: "Email",
      width: "25vh",
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {row.email}
        </span>
      ),
    },
    {
      name: "Phone",
      width: "20vh",
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {row.phoneNumber}
        </span>
      ),
    },
    {
      name: "Message",
      width: "50vh",
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {row.message}
        </span>
      ),
    },
    {
      name: "Timestamp",
      width: "25vh",
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {moment(row.createdAt).format("MMM DD, YYYY HH:MM A")}
        </span>
      ),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="flex items-center">
          <Button onClick={() => {
            setDeleteId(row?._id);
            setDeleteModal(!deleteModal);
          }} className="p-2 rounded-full shadow-none hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-5">
            <FiTrash className="w-4 h-4 text-greyText" />
          </Button>
        </div>
      ),
    },
  ];

  /* USE-EFFECTS */
  useEffect(() => {
    getContactUsListFunction();
  }, [page, sizePerPage, search]);

  /* LOADING SCREEN FOR DATATABLE */
  const LoadingScreen = () => {
    return <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
      <p className="text-sm font-proxima-semibold text-black text-center">Please wait!</p>
      <p className="text-sm font-proxima-semibold text-black text-center">We are fetching data </p>
    </div>
  }

  const NoDataScreen = () => {
    return <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
      <p className="text-sm font-proxima-semibold text-black text-center">
        There are no queries to display.
      </p>
    </div>
  }

  return (
    <section className="px-0 py-2 xl:p-10 lg:p-10 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Contact Us Queries | CIDA Perfumes</title>
      </Helmet>

      <div className="container-full-width">
        {/* HEADING */}
        <div className="block xl:flex lg:flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-proxima-bold text-black tracking-tight">
              Contact Us
            </h1>
            <h2 className="text-lg font-proxima-regular text-greyText tracking-tight">
              Manage the queries by your customers from website.
            </h2>
          </div>
          <div className="block xl:flex lg:flex items-center gap-2">
            {/* SEARCHBAR */}
            <div className="w-3/4 xl:w-full lg:w-full mt-2 xl:mt-0 lg:mt-0">
              <Input
                type="text"
                placeholder="Search..."
                name="search"
                id="search"
                value={search}
                onChange={(e) => setSearch(e?.target?.value)}
              />
            </div>

          </div>
        </div>

        <div className="mt-5">
          <DataTable
            className="data-table"
            columns={columns}
            data={totalDocs > 0 ? contactUsList : []}
            progressPending={loading}
            progressComponent={<LoadingScreen />}
            pagination
            paginationServer
            paginationTotalRows={totalDocs}
            onChangeRowsPerPage={handlePerPageChange}
            onChangePage={handlePageChange}
            noDataComponent={<NoDataScreen />}
          />
        </div>

        <Dialog
          open={deleteModal}
          handler={() => setDeleteModal(!deleteModal)}
          size="xs"
          animate={{
            mount: { scale: 1, y: 0 },
            unmount: { scale: 0.9, y: -100 },
          }}
        >
          <DialogBody className="p-0">
            <div className="border-b border-authBorder px-5 py-3 flex items-center justify-between">
              <h5 className="text-lg font-proxima-bold text-black tracking-tight">
                Delete Category
              </h5>
              <Button
                className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                onClick={() => setDeleteModal(!deleteModal)}
              >
                <IoClose className="w-4 h-4 text-greyText" />
              </Button>
            </div>
            <div className="p-5 border-b border-authBorder">
              <p className="text-base font-proxima-regular text-black">
                Are you sure you want to delete this category?
              </p>
            </div>
            <div className="flex items-center justify-end px-5 py-3">
              <Button onClick={handleDelete} className="text-sm shadow-none hover:shadow-none bg-logoYellow hover:bg-opacity-80 px-5 py-3 rounded-md font-proxima-semibold text-white transition-all duration-300 ease-in-out normal-case">
                Delete details
              </Button>
            </div>
          </DialogBody>
        </Dialog>
      </div>
    </section>
  );
};

export default ContactUs;
